/**
 * `cn` — conditional class-name helper combining clsx (conditional logic)
 * and tailwind-merge (resolves conflicting Tailwind utilities to the last one).
 */
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
